import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form } from "react-bootstrap";
import chiediConferma from '../../../../components/Util/chiediConferma';
import { DocumentText, DollarSquare, CardAdd, Judge} from "iconsax-react";
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { sports, italianProvinces, tipologiaStruttura } from "../../../../components/Util/enum";
import { format } from 'date-fns';
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { useProfile } from "../../../../../hooks/useProfile";
import { saveSaleDraft, loadSaleDraft, clearSaleDraft } from "../../../../components/Util/saleDraft";
import PrezziPagamento from "../../../../components/Vendite/PrezziPagamento";
import { numeroDaTesto } from "../../../../components/Util/prezzi";
import { segnalaMancanti } from "../../../../components/Util/campiMancanti";

// Campi obbligatori vuoti o scritti male (regola «Dati mancanti»): niente finestre né tooltip del browser,
// si evidenziano i campi con cosa manca.
const campiNonValidi = (form) => {
    const lista = [];
    Array.from(form.elements).forEach((el, i) => {
        if (!el.willValidate || el.checkValidity()) return;
        if (!el.id) el.id = `campo-${el.name || 'richiesto'}-${i}`;
        let etichetta = '';
        for (let p = el.parentElement, n = 0; p && n < 5 && !etichetta; p = p.parentElement, n += 1) {
            const l = p.querySelectorAll('label');
            if (l.length === 1) etichetta = l[0].textContent.replace(/\s*\*+\s*$/, '').trim();
            else if (l.length > 1) break;
        }
        const messaggio = el.validity.valueMissing || !el.validationMessage
            ? (etichetta ? `Manca il campo «${etichetta}»` : 'Dato mancante')
            : el.validationMessage;
        lista.push({ campo: el, messaggio });
    });
    return lista;
};

// Come segnalaMancanti, ma un campo già segnalato non si ripete.
const segnala = (lista) => {
    const visti = new Set();
    return segnalaMancanti(lista.filter(({ campo }) => {
        const el = typeof campo === 'string' ? (document.getElementById(campo) || document.querySelector(`[name="${campo}"]`)) : campo;
        if (!el || visti.has(el)) return false;
        visti.add(el);
        return true;
    }));
};

export const UserVenuesNew = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const formRefs = useRef({});
    const [loadingShowed, setLoadingShowed] = useState(false);
    const [courses, setCourses] = useState([]);
    const [juniors, setJuniors] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [userSearchInput, setUserSearchInput] = useState("");
    const [isForJunior, setIsForJunior] = useState(false);
    const [termsAndConditions, setTermsAndConditions] = useState(false);
    const [termsAndConditionsMarketing, setTermsAndConditionsMarketing] = useState(false);
    const [termsAndConditionsImage, setTermsAndConditionsImage] = useState(false);
    
    // Nuovi stati per venue availability
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedSport, setSelectedSport] = useState(null);
    const [availableVenues, setAvailableVenues] = useState([]);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [loadingVenues, setLoadingVenues] = useState(false);
    // Impianti prenotabili della struttura: quelli visibili ai clienti e con uno sport
    const [impianti, setImpianti] = useState([]);
    // Orari dell'impianto da mostrare spenti finché non si sceglie il giorno
    const [orariAnteprima, setOrariAnteprima] = useState([]);
    const [prefill, setPrefill] = useState(null);
    
    const [formData, setFormData] = useState({
        prezzo_praticato: '',
        playerId: '', 
        juniorId: '',
        selectedDate: '',
        sportType: '',
        venueId: '',
        slotStartTime: '',
        slotEndTime: '',
        isMember: '',
        isFederated: '',
        corso_user: '',
        corso_user_junior: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        is_omaggio: false,
        is_pagato: false,
        modalita_pagamento: '',
        skip_generate_document: false
    });

    const { profile, loading: profileLoading } = useProfile();
    const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';

    useEffect(() => {
        if (!profileLoading && profile && !isFatturazioneConfirmed && formData.skip_generate_document !== true) {
            setFormData(prev => ({ ...prev, skip_generate_document: true }));
        }
    }, [profileLoading, profile, isFatturazioneConfirmed, formData.skip_generate_document]);

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ];

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ];
    
    const optionsGenerateDocument = [
        { value: false, label: "Si" },
        { value: true, label: "No" }
    ];

    // Funzione helper per formattare le date
    // Il giorno scritto come lo si legge: «giovedì 25/09/2026»
    const GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
    const giornoPerEsteso = (date) => {
        if (!date) return '';
        try {
            const d = new Date(date);
            return `${GIORNI[d.getDay()]} ${format(d, 'dd/MM/yyyy')}`;
        } catch (error) {
            return String(date);
        }
    };

    const formatDateWithTime = (date, time) => {
        if (!date || !time) return '';
        try {
            const dateObj = new Date(date);
            const formattedDate = format(dateObj, 'dd/MM/yyyy');
            return `${formattedDate} ${time}`;
        } catch (error) {
            return `${date} ${time}`;
        }
    };

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const coursesApi = await apiClient.getBookingCourses(token);
                    setLoadingShowed(false);

                    let courseOptions = []
                    if(coursesApi) {
                        coursesApi.forEach(element => {
                            if(element.status === 'PURCHASABLE') {
                                courseOptions.push({ 
                                    value: element.id, 
                                    label: element.name, 
                                    sportType: element.sportType, 
                                    expiration_type: element.expiration_type,
                                    standard_price: element.standard_price+' €',
                                    member_price: element.member_price+' €',
                                    federated_price: element.federated_price+' €',
                                })
                            }
                        });
                    }
                    setCourses(courseOptions);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
        }
    }, []);

    // Carica gli impianti della struttura: la prenotazione parte dalla scelta dell'impianto.
    // Stesso filtro della disponibilità nel backend (visibile ai clienti, con uno sport).
    useEffect(() => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const token = JSON.parse(tokenDetailsString).idToken;
        new MyApiClient().getVenues(token).then(dati => {
            const elenco = Array.isArray(dati) ? dati : (dati?.data || dati?.venues || []);
            setImpianti(elenco
                .filter(v => v.showToCustomers !== false && v.sportType)
                .map(v => ({
                    value: v.id,
                    label: v.name,
                    sportType: v.sportType,
                    descrizione: v.description || '',
                }))
                .sort((a, b) => a.label.localeCompare(b.label)));
        }).catch(errore => console.error('Impianti non letti', errore));
    }, []);

    // Auto-selezione del corso se presente nell'URL
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const courseId = urlParams.get('courseId');
        
        if (courseId && courses.length > 0) {
            // Timeout per simulare il click dell'utente dopo che tutto è caricato
            setTimeout(() => {
                const courseToSelect = courses.find(course => course.value === courseId);
                if (courseToSelect) {
                    handleSelectChange(courseToSelect, 'course_id');
                }
            }, 1000); // 1 secondo di delay
        }
    }, [courses, location.search]);

    // Precompilazione da querystring: playerId e playerName
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qsPlayerId = params.get('playerId');
        const qsPlayerName = params.get('playerName');
        if (qsPlayerId && qsPlayerName) {
            const option = { value: qsPlayerId, label: qsPlayerName };
            setSelectedUser(option);
            setFormData(prev => ({ ...prev, playerId: qsPlayerId }));
        }
    }, [location.search]);

    // Precompilazione da querystring (es. dal calendario): impianto, data e orario
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qsDate = params.get('date');
        const qsVenueId = params.get('venueId');
        const qsStart = params.get('startTime');
        const qsEnd = params.get('endTime');

        if (qsDate) {
            setSelectedDate(qsDate);
            setFormData(prev => ({ ...prev, selectedDate: qsDate }));
        }
        if (qsVenueId && impianti.length > 0) {
            const impianto = impianti.find(i => i.value === qsVenueId);
            if (impianto) scegliImpianto(impianto);
        }
        if (qsStart) {
            setPrefill({ startTime: qsStart, endTime: qsEnd || null });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [impianti, location.search]);

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/facilities');
        }
    };

    // Funzione per la ricerca asincrona degli utenti per il componente Select unificato
    const loadUserOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const playersData = await apiClient.getProfilesByFilters(token, 10000, inputValue, 'IDS_PLAY');

                if (playersData && playersData.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante la lettura (" + playersData.error + ")");
                    setModalShowed(true);
                    return [];
                } else {
                    const playerOptions = playersData.items.map(element => ({
                        value: element.userId,
                        label: element.name
                    }));
                    return playerOptions;
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return [];
        }
        return [];
    };

    // Gestisce la selezione dell'utente dal componente Select unificato.
    // Cambiando player si azzera quello che apparteneva a quello di prima: junior
    // scelto, suo elenco e dati di fatturazione.
    const handleUserSelect = (selectedOption) => {
        const nuovoId = selectedOption ? selectedOption.value : '';
        const cambiato = nuovoId !== formData.playerId;
        setSelectedUser(selectedOption);
        if (cambiato) {
            setIsForJunior(false);
            setJuniors([]);
        }
        setFormData(prev => (cambiato ? {
            ...prev,
            playerId: nuovoId,
            juniorId: '',
            corso_user_junior: '',
            corso_user: selectedOption ? selectedOption.label : '',
            tipo_cliente: '',
            ragione_sociale: '',
            partita_iva: '',
            codice_destinatario: '',
            nome: '',
            cognome: '',
            codice_fiscale: '',
            email: '',
            indirizzo: '',
            cap: '',
            citta: '',
            provincia: '',
        } : { ...prev, playerId: nuovoId }));
    };

    // Pagina unica: il prezzo e i dati di fatturazione, che nel percorso a passi
    // arrivavano premendo «Avanti», si chiedono appena ci sono cliente e impianto
    // (e lo junior, se serve).
    useEffect(() => {
        if (!formData.playerId || !formData.venueId) return;
        if (isForJunior && !formData.juniorId) return;
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        let annullato = false;

        apiClient.getUserBookingVenuesPreview(token, formData.playerId, formData.juniorId, formData.venueId)
            .then(anteprima => {
                if (annullato || !anteprima?.data) return;
                const d = anteprima.data;
                const italiana = (iso) => (iso ? `${iso.substring(8, 10)}/${iso.substring(5, 7)}/${iso.substring(0, 4)}` : '');
                const r = d.receiver;
                // I dati di fatturazione sono sempre quelli del player scelto: si
                // riscrivono tutti, così cambiando player non restano quelli di prima.
                const fatturazione = r ? {
                    tipo_cliente: r.type === 'business' ? 'azienda' : 'privato',
                    nome: r.type === 'business' ? '' : (r.first_name || ''),
                    cognome: r.type === 'business' ? '' : (r.last_name || ''),
                    ragione_sociale: r.type === 'business' ? (r.denomination || '') : '',
                    partita_iva: r.type === 'business' ? (r.vat_number || '') : '',
                    codice_destinatario: r.type === 'business' ? (r.sdi_code || '') : '',
                    codice_fiscale: r.tax_code || '',
                    email: r.pec || '',
                    indirizzo: r.address || '',
                    cap: r.zip_code || '',
                    citta: r.city || '',
                    provincia: r.province || '',
                } : {};
                setFormData(prev => ({
                    ...prev,
                    venue_price: d.venuePrice + ' €',
                    prezzo_praticato: d.venuePrice,
                    isMember: d.isMember ? 'Si' : 'No',
                    isFederated: d.isFederated ? 'Si' : 'No',
                    dateStart: italiana(d.startDate),
                    dateEnd: italiana(d.endDate),
                    corso_user: selectedUser ? selectedUser.label : prev.corso_user,
                    ...fatturazione,
                }));

                // Senza dati di fatturazione salvati (o senza PEC) si prendono
                // dall'anagrafica del player.
                if (!r || !r.pec) {
                    apiClient.getProfiles(token, formData.playerId).then(playerProfile => {
                        if (annullato || !playerProfile || playerProfile.error) return;
                        const ids = playerProfile.idsPlay || {};
                        const addr = ids.address || {};
                        setFormData(prev => (r
                            ? { ...prev, email: prev.email || ids.email || '' }
                            : {
                                ...prev,
                                tipo_cliente: prev.tipo_cliente || 'privato',
                                nome: ids.givenName || '',
                                cognome: ids.familyName || '',
                                email: ids.email || '',
                                indirizzo: addr.streetAddress || '',
                                cap: addr.postalCode || '',
                                citta: addr.locality || '',
                                provincia: addr.province || '',
                            }));
                    }).catch(errore => console.error('Profilo del player non letto', errore));
                }
            })
            .catch(errore => console.error('Anteprima non riuscita', errore));

        return () => { annullato = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.playerId, formData.venueId, formData.juniorId, isForJunior]);

    // "Crea nuovo cliente" → pagina completa di creazione, poi ritorno qui col cliente selezionato.
    // Snapshot di tutto ciò che l'utente ha inserito, per ripristinarlo al ritorno.
    const buildDraft = () => ({
        formData,
        selectedUser,
        isForJunior,
        userSearchInput,
        termsAndConditions,
        termsAndConditionsMarketing,
        termsAndConditionsImage,
        showingSociOptions,
        showingTesseratiOptions,
        selectedDate,
        selectedSport,
        selectedVenue,
        selectedSlot,
    });

    const goCreateNewCustomer = () => {
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        const clean = params.toString();
        const back = location.pathname + (clean ? `?${clean}` : '');
        navigate(`/struttura/clienti/nuovo?returnTo=${encodeURIComponent(back)}`);
    };

    // Al ritorno dalla creazione: ripristina il form e pre-seleziona cliente/junior.
    useEffect(() => {
        const newCustomerId = searchParams.get('newCustomerId');
        const newCustomerName = searchParams.get('newCustomerName');
        const newJuniorId = searchParams.get('newJuniorId');
        const returning = !!(newCustomerId || newJuniorId);
        const draft = returning ? loadSaleDraft(location.pathname) : null;
        clearSaleDraft(location.pathname);

        if (draft) {
            if (draft.formData) setFormData(draft.formData);
            if (draft.selectedUser) setSelectedUser(draft.selectedUser);
            setIsForJunior(!!draft.isForJunior);
            setUserSearchInput(draft.userSearchInput || '');
            setTermsAndConditions(!!draft.termsAndConditions);
            setTermsAndConditionsMarketing(!!draft.termsAndConditionsMarketing);
            setTermsAndConditionsImage(!!draft.termsAndConditionsImage);
            setShowingSociOptions(!!draft.showingSociOptions);
            setShowingTesseratiOptions(!!draft.showingTesseratiOptions);
            setSelectedDate(draft.selectedDate || '');
            setSelectedSport(draft.selectedSport || null);
            setSelectedVenue(draft.selectedVenue || null);
            setSelectedSlot(draft.selectedSlot || null);
        }

        if (newCustomerId) {
            handleUserSelect({ value: newCustomerId, label: newCustomerName || (draft && draft.selectedUser && draft.selectedUser.label) || 'Cliente' });
            if (newJuniorId) {
                setIsForJunior(true);
                fetchJuniorsFor(newCustomerId).then(list => {
                    setJuniors(list);
                    setFormData(prev => ({ ...prev, juniorId: newJuniorId }));
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : (selectedOption ? selectedOption.value : '');
    
        setFormData(prev => {
            const newData = {
                ...prev,
                [name]: selectedValue,
            };
            
            // Se is_pagato viene impostato su false, resetta anche skip_generate_document
            if (name === 'is_pagato' && !selectedValue) {
                newData.skip_generate_document = (profile && !isFatturazioneConfirmed) ? true : false;
            }
            
            return newData;
        });
    };

    // Scelta dell'impianto: lo sport è il suo, gli orari si rileggono per la data scelta
    const scegliImpianto = (impianto) => {
        setSelectedVenue(impianto);
        setSelectedSport(impianto ? { value: impianto.sportType } : null);
        setFormData(prev => ({
            ...prev,
            venueId: impianto ? impianto.value : '',
            sportType: impianto ? impianto.sportType : '',
            course_name: impianto ? impianto.label : '',
            slotStartTime: '',
            slotEndTime: '',
        }));
        setAvailableSlots([]);
        setSelectedSlot(null);
    };

    // Oggi in formato aaaa-mm-gg: il primo giorno prenotabile
    const oggi = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; })();
    // Giorno completo e da oggi in avanti: solo allora si leggono orari e prenotazioni
    const giornoValido = /^\d{4}-\d{2}-\d{2}$/.test(selectedDate || '') && selectedDate >= oggi;
    const [giornoPassato, setGiornoPassato] = useState(false);

    // Gestisce la selezione della data: l'impianto resta, gli orari si rileggono
    const handleDateChange = (event) => {
        const date = event.target.value;
        // Si prenota da oggi in avanti
        // Mentre si scrive l'anno passa per valori come 0002, 0020, 0202: il giorno si
        // accetta com'è, il controllo del passato si fa uscendo dal campo e alla conferma.
        setGiornoPassato(false);
        setSelectedDate(date);
        setFormData(prev => ({ ...prev, selectedDate: date, slotStartTime: '', slotEndTime: '' }));
        setAvailableSlots([]);
        setSelectedSlot(null);
    };

    // Gestisce la selezione dello slot
    const handleSlotSelect = (slot) => {
        setSelectedSlot(slot);
        setFormData(prev => ({
            ...prev,
            slotStartTime: slot.startTime,
            slotEndTime: slot.endTime
        }));
    };

    // Scelto l'impianto si vedono subito i suoi orari, spenti: si prendono dal primo
    // giorno aperto a partire da oggi (al massimo una settimana avanti).
    useEffect(() => {
        setOrariAnteprima([]);
        if (!selectedVenue) return;
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const tokenDetails = JSON.parse(tokenDetailsString);
        const apiClient = new MyApiClient();
        let annullato = false;
        (async () => {
            for (let i = 0; i < 7 && !annullato; i++) {
                const d = new Date();
                d.setDate(d.getDate() + i);
                const giorno = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                try {
                    const dati = await apiClient.getVenueAvailability(tokenDetails.idToken, giorno, selectedVenue.sportType, tokenDetails.localId);
                    const venue = Array.isArray(dati) ? dati.find(v => v.venueId === selectedVenue.value) : null;
                    if (venue && venue.availableSlots && venue.availableSlots.length > 0) {
                        if (!annullato) setOrariAnteprima(venue.availableSlots.map(({ startTime, endTime }) => ({ startTime, endTime })));
                        return;
                    }
                } catch (errore) {
                    console.error('Orari non letti', errore);
                    return;
                }
            }
        })();
        return () => { annullato = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVenue]);

    // Orari dell'impianto scelto nella data scelta: liberi e occupati
    useEffect(() => {
        if (!giornoValido || !selectedVenue) {
            setAvailableVenues([]);
            setAvailableSlots([]);
            return;
        }
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const tokenDetails = JSON.parse(tokenDetailsString);
        let annullato = false;
        setLoadingVenues(true);
        new MyApiClient().getVenueAvailability(tokenDetails.idToken, selectedDate, selectedVenue.sportType, tokenDetails.localId)
            .then(dati => {
                if (annullato) return;
                setLoadingVenues(false);
                if (!dati || dati.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Non è stato possibile leggere gli orari dell'impianto");
                    setModalShowed(true);
                    setAvailableVenues([]);
                    setAvailableSlots([]);
                    return;
                }
                setAvailableVenues(dati);
                const venue = dati.find(v => v.venueId === selectedVenue.value);
                setAvailableSlots(venue ? (venue.availableSlots || []) : []);
            })
            .catch(errore => {
                if (annullato) return;
                console.error('Disponibilità non letta', errore);
                setLoadingVenues(false);
                setAvailableSlots([]);
            });
        return () => { annullato = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDate, selectedVenue, giornoValido]);

    // Orario arrivato dall'URL: si sceglie appena ci sono gli orari
    useEffect(() => {
        if (!prefill || availableSlots.length === 0) return;
        const slot = availableSlots.find(s => s.startTime === prefill.startTime && (!prefill.endTime || s.endTime === prefill.endTime));
        if (slot) sceltaOrario(slot);
        setPrefill(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableSlots, prefill]);

    // Un orario occupato non si prende: lo si dice
    const sceltaOrario = (slot) => {
        if (!slot.isAvailable) {
            setModalTitle('Impianto occupato');
            setModalText(`${selectedVenue ? selectedVenue.label : "L'impianto"} è già occupato ${giornoPerEsteso(selectedDate)} dalle ${slot.startTime} alle ${slot.endTime}. Scegli un altro orario o un'altra data.`);
            setModalShowed(true);
            return;
        }
        handleSlotSelect(slot);
    };

    const handleCheckboxChangeTermsAndConditions = (event) => {
        setTermsAndConditions(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsMarketing = (event) => {
        setTermsAndConditionsMarketing(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsImage = (event) => {
        setTermsAndConditionsImage(event.target.checked);
    };

    // Carica i junior di un cliente (parent) e li mappa per la Lista Juniors.
    const fetchJuniorsFor = async (playerId) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return [];
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();
            const juniorsData = await apiClient.getJuniorsByParent(token, playerId);
            const data = [];
            if (juniorsData) {
                juniorsData.forEach(element => {
                    let status = null;
                    if (element.profileStatus === 'INACTIVE') status = { label: 'Inattivo', class: 'text-danger' };
                    else if (element.profileStatus === 'ACTIVE') status = { label: 'Attivo', class: 'text-warning' };
                    else if (element.profileStatus === 'COMPLETED') status = { label: 'Completato', class: 'text-success' };
                    data.push({
                        registration_date: format(element.createdAt, 'dd/MM/yyyy HH:mm:ss'),
                        id: element.userId,
                        nome: element.givenName,
                        cognome: element.familyName,
                        status_label: status,
                    });
                });
            }
            return data;
        } catch (error) {
            console.error('Error fetching juniors:', error);
            return [];
        }
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsForJunior(checked);
        if (checked && formData.playerId !== '') {
            setLoadingShowed(true);
            fetchJuniorsFor(formData.playerId).then(list => {
                setLoadingShowed(false);
                setJuniors(list);
            });
        } else {
            setIsForJunior(false);
            setJuniors([]);
            setFormData(prev => ({ ...prev, juniorId: '' }));
        }
    };

    // "Aggiungi Junior" → pagina di creazione junior (parent = cliente selezionato), poi ritorno qui col junior selezionato.
    const goCreateNewJunior = () => {
        if (!formData.playerId) return;
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        params.set('newCustomerId', formData.playerId);
        params.set('newCustomerName', selectedUser?.label || '');
        const back = location.pathname + '?' + params.toString();
        const pName = selectedUser?.label || '';
        navigate(`/struttura/junior/nuovo?parentId=${encodeURIComponent(formData.playerId)}&parentName=${encodeURIComponent(pName)}&returnTo=${encodeURIComponent(back)}`);
    };

    const juniors_data_column = [
        {
            // La scelta sta nella prima colonna e resta segnata: un solo junior alla volta
            Header: '',
            accessor: 'scelta',
            disableFilters: true,
            disableGlobalFilter: true,
            Cell: ({ row }) => {
                const scelto = formData.juniorId === row.original.id;
                return (
                    <input
                        type="radio"
                        name="juniorScelto"
                        checked={scelto}
                        onChange={() => setFormData(prev => ({
                            ...prev,
                            juniorId: row.original.id,
                            corso_user_junior: `${row.original.nome} ${row.original.cognome}`,
                        }))}
                    />
                );
            },
        },
        {
            Header: 'Nome e cognome',
            accessor: 'name',
            Cell: ({ row }) => row.original.nome + ' ' + row.original.cognome,
        },
        {
            Header: 'Data registrazione',
            accessor: 'registration_date',
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'status_label',
            disableFilters: true,
            Cell: ({ value }) => (
                <div className="d-flex align-items-center">
                    <i className={`fa fa-circle me-1 ${value ? value.class : ''}`}></i>
                    {value ? value.label : ''}
                </div>
            ),
        },
    ];

    /** Conferma dalla pagina unica: controlla tutti i riquadri, poi salva. */
    const confermaAcquisto = () => {
        const lista = [];
        if (!selectedVenue) lista.push({ campo: 'impianto', messaggio: "Manca l'impianto da prenotare" });
        if (!selectedDate) lista.push({ campo: 'selectedDate', messaggio: 'Manca il giorno della prenotazione' });
        else if (!giornoValido) lista.push({ campo: 'selectedDate', messaggio: 'Il giorno deve essere da oggi in avanti' });
        else if (selectedVenue && !selectedSlot) lista.push({ campo: 'orario-slot', messaggio: "Manca l'orario: scegline uno libero" });
        if (isForJunior && !formData.juniorId) lista.push({ campo: 'junior-lista', messaggio: 'Manca lo junior: sceglilo dalla lista' });
        for (const form of Object.values(formRefs.current)) {
            if (!form) continue;
            // Partita IVA e codice fiscale hanno un formato loro: il browser da solo
            // non li controlla, glielo diciamo qui.
            for (const campo of form.elements) {
                if (campo.name === 'partita_iva') {
                    campo.setCustomValidity(
                        campo.value && (campo.value.length !== 11 || isNaN(campo.value))
                            ? 'La partita IVA deve contenere esattamente 11 cifre numeriche.'
                            : '');
                }
                if (campo.name === 'codice_fiscale' && campo.value) {
                    const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
                    const valido = (campo.value.length === 16 && cfRegex.test(campo.value))
                        || (campo.value.length === 11 && !isNaN(campo.value));
                    campo.setCustomValidity(valido ? '' : 'Controlla il formato del codice fiscale (16 caratteri) o della partita IVA (11 cifre)');
                }
            }
            lista.push(...campiNonValidi(form));
        }
        if (!termsAndConditions) lista.push({ campo: 'accetta-termini', messaggio: 'Il cliente deve accettare i termini e condizioni della struttura' });
        if (segnala(lista) > 0) return;
        handleSaveClick(4, 'PURCHASABLE');
    };

    /** Salvataggio: percorso unico, la pagina è una sola. */
    const handleSaveClick = (numOfTab, status) => {
        if (!termsAndConditions && segnala([{ campo: 'accetta-termini', messaggio: 'Il cliente deve accettare i termini e condizioni della struttura' }]) > 0) return;
        
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            formData.clubId = tokenDetails.localId;
            formData.status = status;
            saveConfirm();
        }
    };

    const saveConfirm = () => {
        chiediConferma({ titolo: 'Confermare l\'acquisto?', testo: 'L\'acquisto sarà effettivo solo quando risulta pagato.', conferma: 'Conferma', variante: 'primary' })
            .then((ok) => { if (ok) saveData(); });
    };

    const saveData = async () => {


        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const userConsents = [];
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'PHOTO_USAGE_BY_STRUCTURE',
                    consent: termsAndConditionsMarketing
                });
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'MARKETING_BY_STRUCTURE',
                    consent: termsAndConditionsImage
                });

                const saveData = {
                    playerId: formData.playerId,
                    venueId: formData.venueId,
                    clubId: formData.clubId,
                    price: formData.prezzo_praticato === '' ? undefined : numeroDaTesto(formData.prezzo_praticato),
                    userConsents: userConsents,
                    bookingDate: selectedDate,
                    startTime: selectedSlot ? selectedSlot.startTime : "",
                    endTime: selectedSlot ? selectedSlot.endTime : "",
                }

                if(formData.juniorId) saveData.juniorId = formData.juniorId;
                // Omaggio: il motivo resta sull'acquisto, nel campo nota
                if(formData.is_omaggio && formData.nota_omaggio) {
                    saveData.note = formData.nota_omaggio;
                }
                // L'omaggio viaggia come le altre forme di pagamento: e' il backend a
                // sapere che chiude a zero e non emette documento.
                if(formData.is_pagato && formData.modalita_pagamento) {
                    saveData.payment_method = formData.modalita_pagamento;
                    saveData.paymentDate = new Date().toISOString().slice(0, 10);
                }
                if(formData.skip_generate_document) {
                    saveData.skip_generate_document = true;
                }

                const dati_fatturazione = {
                    tax_code: formData.codice_fiscale,
                    pec: formData.email,
                    address: formData.indirizzo,
                    zip_code: formData.cap,
                    city: formData.citta,
                    province: formData.provincia,
                    nation: 'IT',
                    country_code: 'IT',
                }
                if(formData.tipo_cliente === 'privato') {
                    dati_fatturazione.type = 'consumer';
                    dati_fatturazione.first_name = formData.nome;
                    dati_fatturazione.last_name = formData.cognome;
                } else if(formData.tipo_cliente === 'azienda') {
                    dati_fatturazione.type = 'business';
                    dati_fatturazione.denomination = formData.ragione_sociale;
                    dati_fatturazione.vat_number = formData.partita_iva;
                    dati_fatturazione.sdi_code = formData.codice_destinatario;
                }

                saveData.receiver = dati_fatturazione;

                setLoadingShowed(true);
                const result = await apiClient.createUserBookingVenue(token, saveData);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/sales');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

    const tabData = [
        {
            id: 'informazioni_generali',
            name: "Informazioni generali",
            icon: <i className="fas fa-info-circle me-2"></i>,
            content: (
                <>
                    <Card>
                        <Card.Body>
                            <Form ref={el => formRefs.current[0] = el} noValidate>
                                {/* Per prima cosa si sceglie cosa prenotare: l'impianto, il giorno, l'orario.
                                    Lo sport è quello dell'impianto. */}
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label htmlFor="impianto">Impianto *</Form.Label>
                                        <Select
                                            inputId="impianto"
                                            placeholder="Scegli l'impianto..."
                                            name="venueId"
                                            value={selectedVenue}
                                            onChange={scegliImpianto}
                                            options={impianti}
                                            noOptionsMessage={() => 'Nessun impianto prenotabile'}
                                            className="mt-2"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label htmlFor="selectedDate">Giorno</Form.Label>
                                        <Form.Control
                                            id="selectedDate"
                                            className="mt-2"
                                            type="date"
                                            name="selectedDate"
                                            value={selectedDate}
                                            min={oggi}
                                            onBlur={() => setGiornoPassato(!!selectedDate && !giornoValido)}
                                            onChange={handleDateChange}
                                            required
                                        />
                                    </Col>
                                </Row>

                                {giornoPassato && (
                                    <div className="sid-avviso is-errore mt-3">Si può prenotare da oggi in avanti: scegli un giorno a partire da oggi.</div>
                                )}
                                {selectedVenue && (
                                    <div className="mt-4">
                                        <Form.Label id="orario-slot">Orario *</Form.Label>
                                        {!giornoValido ? (
                                            /* Impianto scelto, giorno no: gli orari si vedono spenti */
                                            orariAnteprima.length > 0 ? (
                                                <>
                                                    <div className="sid-slot-griglia">
                                                        {orariAnteprima.map(slot => (
                                                            <button type="button" key={slot.startTime} className="sid-slot is-spento" disabled>
                                                                <span className="sid-slot__ore">{slot.startTime} – {slot.endTime}</span>
                                                                <span className="sid-slot__stato">Scegli il giorno</span>
                                                            </button>
                                                        ))}
                                                    </div>
                                                    <div className="sid-slot-nota">Scegli il giorno per vedere quali orari sono liberi.</div>
                                                </>
                                            ) : (
                                                <div className="sid-slot-nota">Scegli il giorno per vedere gli orari.</div>
                                            )
                                        ) : loadingVenues ? (
                                            <div className="sid-slot-nota"><Spinner animation="border" size="sm" /> Lettura degli orari...</div>
                                        ) : availableSlots.length === 0 ? (
                                            <div className="sid-slot-nota">
                                                {selectedVenue.label} non ha orari prenotabili {giornoPerEsteso(selectedDate)}: è chiuso o fuori dagli orari di apertura. Scegli un altro giorno.
                                            </div>
                                        ) : (
                                            <div className="sid-slot-griglia">
                                                {availableSlots.map(slot => {
                                                    const scelto = selectedSlot && selectedSlot.startTime === slot.startTime;
                                                    return (
                                                        <button
                                                            type="button"
                                                            key={slot.startTime}
                                                            className={`sid-slot${scelto ? ' is-scelto' : ''}${slot.isAvailable ? '' : ' is-occupato'}`}
                                                            onClick={() => sceltaOrario(slot)}
                                                        >
                                                            <span className="sid-slot__ore">{slot.startTime} – {slot.endTime}</span>
                                                            <span className="sid-slot__stato">{slot.isAvailable ? (scelto ? 'Scelto' : 'Libero') : 'Occupato'}</span>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="sid-gen-panel mt-4">
                                    <div className="sid-gen-panel__titolo">Chi partecipa</div>
                                    <p className="sid-gen-panel__aiuto">
                                        Scegli il cliente, oppure creane uno nuovo. Lo junior si può indicare <b>solo dopo aver scelto il
                                        cliente</b>: i suoi junior compaiono qui sotto.
                                    </p>
                                    <Row className="g-4">
                                        <Col md={9}>
    										<Form.Label>Cerca e seleziona un utente di SportId *</Form.Label>
    										<AsyncSelect
                                                    required
                                                    name="playerId"
                                                    value={selectedUser}
                                                    onChange={handleUserSelect}
                                                    onInputChange={(value, meta) => { if (meta.action === 'input-change') setUserSearchInput(value); }}
                                                    loadOptions={loadUserOptions}
                                                    placeholder="Inizia a digitare per cercare un utente (minimo 3 caratteri)..."
                                                    noOptionsMessage={({ inputValue }) => 
                                                        inputValue.length < 3 
                                                            ? "Digita almeno 3 caratteri per iniziare la ricerca" 
                                                            : "Nessun utente trovato"
                                                    }
                                                    loadingMessage={() => "Ricerca in corso..."}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions={false}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            minHeight: "38px",
                                                            height: "38px",
                                                            border: "1px solid #ced4da",
                                                            borderRadius: "0.375rem",
                                                            fontSize: "0.9rem",
                                                            lineHeight: "1.5"
                                                        }),
                                                        valueContainer: (provided) => ({
                                                            ...provided,
                                                            height: "36px",
                                                            padding: "0 8px"
                                                        }),
                                                        input: (provided) => ({
                                                            ...provided,
                                                            margin: "0",
                                                            paddingTop: "0",
                                                            paddingBottom: "0"
                                                        }),
                                                        indicatorsContainer: (provided) => ({
                                                            ...provided,
                                                            height: "36px"
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: "#6c757d",
                                                            fontSize: "0.9rem"
                                                        })
                                                    }}
                                                />
                                        </Col>
                                        <Col md={3} className="d-flex align-items-end justify-content-end">
                                            <Button variant="outline-dark" size="sm" onClick={goCreateNewCustomer}>
                                                + Crea nuovo player
                                            </Button>
                                        </Col>
                                        <Col md={12} className="mt-2">
                                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                        <Row>
                                            <label>
                                                <input
                                                type="checkbox"
                                                checked={isForJunior}
                                                onChange={handleCheckboxChange}
                                                />
                                                &nbsp;&nbsp;&nbsp;Questo impianto viene acquistato per uno junior
                                            </label>
                                        </Row>
    
                                        {isForJunior && (
                                            <>
                                                {formData.playerId && (
                                                    <div className="mb-2 mt-2">
                                                        <Button variant="link" className="p-0" style={{ fontSize: "0.9rem" }} onClick={goCreateNewJunior}>
                                                            Assegna junior
                                                        </Button>
                                                    </div>
                                                )}
                                                <div id="junior-lista">
                                                {juniors && juniors.length > 0 ? (
                                                    <TabellaLista
                                                        cardTitle={'Lista Juniors'}
                                                        hasSearch={false}
                                                        hasFilter={false}
                                                        data_column={juniors_data_column}
                                                        data_json={juniors}
                                                        notPagination={true}
                                                        hasAddMoreAsModal={false}
                                                    />
                                                ) : (
                                                    <p className="text-muted mt-2">Nessun junior collegato a questo cliente. Usa "Assegna junior" per crearne uno.</p>
                                                )}
                                                </div>
                                            </>
                                        )}
                                            </Form>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </>
            ),
        },
        {
            id: 'prezzi',
            name: "Prezzi",
            icon: <DollarSquare size='18' />,
            content: (
                <>
                    <PrezziPagamento
                        formData={formData}
                        setFormData={setFormData}
                        listino={formData.venue_price}
                        isFatturazioneConfirmed={isFatturazioneConfirmed}
                        formRef={el => formRefs.current[3] = el}
                    />
                </>
            ),
        },
        {
            id: 'fatturazione_pagamento',
            name: "Fatturazione e pagamento",
            icon: <CardAdd size='18' />,
            content: (
                <>
                    <Form ref={el => formRefs.current[2] = el} noValidate>
                        <Card>
                            <Card.Header><h4 className="card-title">Dati di fatturazione</h4></Card.Header>
                            <Card.Body>        
                                <Row className="mt-4">
                                    {/* Selezione Tipo Cliente */}
                                    <Col md={12}>
                                        <Form.Label>Tipo Cliente *</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="tipo_cliente"
                                            value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                            options={optionsFatturazione}
                                        />
                                    </Col>
                                </Row>

                                {/* Azienda */}
                                {formData.tipo_cliente === 'azienda' && (
                                    <Row className="mt-4">
                                        <Col lg={4}>
                                            <Form.Label>Ragione sociale</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="ragione_sociale"
                                                value={formData.ragione_sociale}
                                                onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Partita IVA</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="partita_iva"
                                                value={formData.partita_iva}
                                                onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="codice_destinatario"
                                                value={formData.codice_destinatario}
                                                onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Privato */}
                                {formData.tipo_cliente === 'privato' && (
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label>Nome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="nome"
                                                value={formData.nome}
                                                onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Label>Cognome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="cognome"
                                                value={formData.cognome}
                                                onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Campi comuni */}
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Codice Fiscale</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="codice_fiscale"
                                            value={formData.codice_fiscale}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Email PEC / Email</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Indirizzo</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="indirizzo"
                                            value={formData.indirizzo}
                                            onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="cap"
                                            value={formData.cap}
                                            onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>Città</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="citta"
                                            value={formData.citta}
                                            onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Provincia *</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="provincia"
                                            value={italianProvinces.find(option => option.value === formData.provincia)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                            options={italianProvinces}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Nazione</Form.Label>
                                        <Form.Control
                                            required
                                            readOnly
                                            className="mt-2"
                                            type="text"
                                            name="nazione"
                                            value="Italia"
                                            onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Form>
                </>
            ),
        },
        {
            id: 'riepilogo',
            name: "Consensi",
            icon: <Judge size='18' />,
            content: (
                <>
                    <Card>
                        <Card.Header><h4 className="card-title">Consensi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Row>
                                    <label>
                                        <input
                                        id="accetta-termini"
                                        type="checkbox"
                                        checked={termsAndConditions}
                                        onChange={handleCheckboxChangeTermsAndConditions}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Il cliente accetta <a style={{ color: 'var(--primary)' }} target="_blank" href="https://sportid.it/termini-e-condizioni/strutture-e-player/" rel="noreferrer">termini e condizioni della struttura</a> *</b>
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsMarketing}
                                        onChange={handleCheckboxChangeTermsAndConditionsMarketing}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Attività di marketing</b><br></br>
                                        Autorizzo il centro sportivo a inviarmi comunicazioni promozionali relative a eventi, corsi, 
                                        offerte e iniziative tramite email, SMS o altri canali.
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsImage}
                                        onChange={handleCheckboxChangeTermsAndConditionsImage}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Uso dell'immagine</b><br></br>
                                        Autorizzo il centro sportivo all’utilizzo di foto e video in cui potrei comparire, realizzati durante le attività, 
                                        per finalità informative, promozionali e di comunicazione sui canali ufficiali (sito web, social media, materiali informativi), 
                                        nel rispetto della normativa sulla privacy (Reg. UE 2016/679 - GDPR).
                                    </label>
                                </Row>
                            </Row>
                        </Card.Body>
                    </Card>
                </>
            ),
        }
    ];

    return (
        <>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <div className="custom-tab-1">
                {/* Pagina unica: le sezioni del vecchio percorso a passi, una sotto l'altra. */}
                <Row className="align-items-start">
                    <div className="col-12">
                        {tabData.map((data, i) => (
                            <div key={data.id} className={i > 0 ? 'mt-4' : undefined}>
                                {data.content}
                            </div>
                        ))}
                        {/* I tasti chiudono la colonna dei riquadri, a destra sul loro bordo. */}
                        <div className="d-flex justify-content-end gap-4 mt-4">
                            <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                            <Button className="btn btn-primary" onClick={confermaAcquisto}>Conferma</Button>
                        </div>
                    </div>
                </Row>
            </div>

        </>
    )

}
export default UserVenuesNew;